import { TouchableOpacity, ActivityIndicator } from "react-native";
import Text from "@/components/shared/AppText";
import React from "react";
import tw from "twrnc";
import { brandColor } from "../globalStyle";
import { Ionicons } from "@expo/vector-icons";

const OnboardingButton = ({
  text,
  style,
  icon,
  loading,
  disabled,
  dark,
  bordered,
  ...props
}) => {
  // Must be a real boolean: Android crashes (UnexpectedNativeTypeException in
  // accessibilityState) when `disabled` is e.g. a Formik error string.
  const isDisabled = !!(disabled || loading);

  return (
    <TouchableOpacity
      style={[
        tw`mb-2.5 h-[62px] rounded-lg items-center justify-center flex-row`,
        { backgroundColor: dark ? "#fff" : brandColor },
        bordered && {
          borderWidth: 1,
          borderColor: dark ? "#3f5b7a" : brandColor,
          backgroundColor: "transparent",
        },
        isDisabled && tw`opacity-70`,
        style,
      ]}
      disabled={isDisabled}
      {...props}
    >
      {!!icon && !loading && (
        <Ionicons
          name={icon}
          size={24}
          color={dark ? "#3f5b7a" : "white"}
          style={tw`mr-1.5`}
        />
      )}
      {loading && (
        <ActivityIndicator
          color={dark ? "#3f5b7a" : "#fff"}
          style={tw`mr-1.5`}
        />
      )}
      <Text
        style={[
          tw`text-base text-center`,
          { color: dark ? "#3f5b7a" : "white" },
          !icon && !loading && tw`flex-1 text-center`,
        ]}
        numberOfLines={1}
      >
        {text}
      </Text>
    </TouchableOpacity>
  );
};

export default OnboardingButton;
